import { render, staticRenderFns } from "./form-inicio.vue?vue&type=template&id=2586efe4&"
import script from "./form-inicio.vue?vue&type=script&lang=js&"
export * from "./form-inicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QCard,QCardSection,QInput,QIcon,QBtn} from 'quasar'
component.options.components = Object.assign({QPage,QCard,QCardSection,QInput,QIcon,QBtn}, component.options.components || {})
